import permissions from '@/enums/permissions';

const BlacklistRede = [
    {
        path: '/blacklist-rede',
        name: 'blacklist-rede',
        component: () => import('@/views/pages/BlacklistRede/BlacklistRede.vue'),
        meta: {
            permissions: permissions.blacklistRede,
        },
    },
];

export default BlacklistRede;
